import {
  SET_LOADING_DATA,
  GET_LIST_ALL_REQUEST,
  GET_LIST_ALL_SUCCESS,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE
} from './client-position-report-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const getAllClientPositionReportsRequest = (filters?: any) => {
  return {
    type: GET_LIST_ALL_REQUEST,
    filters
  };
};

export const getAllClientPositionReportsSuccess = payload => {
  return {
    type: GET_LIST_ALL_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};
